import { LuCrown } from "react-icons/lu";
import React, { useEffect, useState } from 'react';
import {Navigate, useParams, useLocation, Link, useNavigate} from 'react-router-dom';
import '../Profile.css';
import Post from "../components/Post";
import { Button } from 'react-bootstrap';
import blank_cover from "../utils/blank_cover.png";
import { Modal, Form } from 'react-bootstrap';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

function checkType(value) {
    if (!isNaN(value) && Number.isInteger(Number(value))) {
        return 'int';
    } else if (typeof value === 'string') {
        return 'string';
    } else {
        return 'other';
    }
}


const Profile = () => {
    const { id } = useParams();
    const location = useLocation();
    const echoUser = localStorage.getItem('echo_user');
    const userLvl = Number(localStorage.getItem('fw_user_lvl') || 0);
    const admin = userLvl > 1;
    const navigate = useNavigate();
    const [onlineUsers, setOnlineUsers] = useState([]);
    const [viewMode, setViewMode] = useState('timeline');
    const [flwBtn, setFlwBtn] = useState(false);
    const [redirect, setRedirect] = useState(null);
    const [userData, setUserData] = useState(null);
    const [userFlwData, setFlwUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [userPosts, setUserPosts] = useState([]);
    const [timeLineCount, setTimeLineCount] = useState(0);
    const [galleryCount, setGalleryCount] = useState(0);
    const [followed, setFollowed] = useState(0);
    const [vipSettings, setVipSettings] = useState(null);

    const fullUrl = (path) => {
        if (!path) return null;
        return path.startsWith('http') ? path : `https://fantasyworldtrpg.cz${path}`;
    };
    const [showCoverModal, setShowCoverModal] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [coverFile, setCoverFile] = useState(null);

    const handleUploadCover = async () => {
        if (!coverFile) return;
        setUploading(true);

        const reader = new FileReader();
        reader.onloadend = async () => {
            const base64 = reader.result.replace(/^data:image\/[a-z]+;base64,/, '');

            try {
                const res = await fetch("https://api.fantasyworldtrpg.cz/echo/update_cover.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        user: echoUser,
                        image_base64: base64
                    })
                });

                const data = await res.json();
                if (data.success && data.url) {
                    setUserData(prev => ({ ...prev, cover_img: data.url }));
                    setShowCoverModal(false);
                } else {
                    alert("Chyba při nahrávání obrázku");
                }
            } catch (err) {
                console.error("Chyba:", err);
            } finally {
                setUploading(false);
            }
        };

        reader.readAsDataURL(coverFile);
    };

    const toggleFollow = async () => {
        setFlwBtn(true);
        try {
            const res = await fetch('https://api.fantasyworldtrpg.cz/echo/follow_toggle.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    user: localStorage.getItem("echo_user"),
                    target: id
                })
            });

            const data = await res.json();
            if (data.success) {
                setFollowed(data.followed);
                setFlwBtn(false);
            }
        } catch (error) {
            console.error("Chyba při přepínání sledování:", error);
            setFlwBtn(false);
        }
    };


    // Přesměrování pokud není ID, ale máme echoUser
    useEffect(() => {
        if (!id && echoUser) {
            setRedirect(`/profile/${echoUser}`);
        }
    }, [id, echoUser]);

    useEffect(() => {
        const uid = localStorage.getItem("echo_user");
        if (!uid) return;

        const ping = async () => {
            try {
                const res = await fetch("https://api.fantasyworldtrpg.cz/echo/online.php", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ uid })
                });

                const data = await res.json();
                if (data.success && Array.isArray(data.onlineUsers)) {
                    setOnlineUsers(data.onlineUsers);
                }
            } catch (err) {
                console.error("Chyba při pingnutí online:", err);
            }
        };

        ping();

        const interval = setInterval(ping, 30000);

        return () => clearInterval(interval);
    }, []);

    // Načti data
    useEffect(() => {
        if (!id) return;

        const fetchProfile = async () => {
            setLoading(true);
            setUserData(null);
            try {
                const res = await fetch('https://api.fantasyworldtrpg.cz/echo/profile.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id }),
                });

                const vipRes = await fetch('https://api.fantasyworldtrpg.cz/echo/get_vip_settings.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ user: id })
                });
                const vipJson = await vipRes.json();
                if (vipJson.success && vipJson.settings) {
                    setVipSettings(vipJson.settings);
                    console.log(vipJson);
                }

                const respost = await fetch('https://api.fantasyworldtrpg.cz/echo/profileposts.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ echo_user: id }),
                });

                const flwCheck = await fetch('https://api.fantasyworldtrpg.cz/echo/check_follow.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ user: localStorage.getItem("echo_user"), target: id })
                });
                const flwData = await flwCheck.json();
                if (flwData.success) {
                    setFollowed(flwData.followed);
                }

                const data = await res.json();
                if (data.status === 'success') {
                    setUserData(data.user);
                    setFlwUserData(data.flw);
                    setTimeLineCount(data.timeline);
                    setGalleryCount(data.gallery);
                } else {
                    setUserData(null);
                }

                const dataPost = await respost.json();
                if (dataPost.status === 'success') {
                    setUserPosts(dataPost.posts);
                } else {
                    setUserPosts(null);
                }
            } catch (err) {
                console.error('Chyba při načítání profilu:', err);
                setUserData(null);
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, [id]);

    useEffect(() => {
        if (userData && checkType(id) === "string") {
            navigate(`/profile/${userData.id}`, { replace: true });
        }
    }, [userData, id]);

    if (redirect) return <Navigate to={redirect} replace />;
    if (loading) return <div className="text-center my-5">⏳ Načítání profilu...</div>;
    if (!userData) return <div className="text-center my-5 text-danger">❌ Uživatel nenalezen</div>;
    console.log("account_type", userData.account_type);
    return (
        <>
            <Modal show={showCoverModal} onHide={() => setShowCoverModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-dark">Změnit cover fotku</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label className="text-dark">Vyber obrázek (max 10MB)<br/>Doporučená velikost 1300x300px</Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={(e) => setCoverFile(e.target.files[0])}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowCoverModal(false)}>
                        Zavřít
                    </Button>
                    <Button variant="danger" disabled={uploading || !coverFile} onClick={handleUploadCover}>
                        {uploading ? "Nahrávám..." : "Nahrát"}
                    </Button>
                </Modal.Footer>
            </Modal>

            <div className="container py-5 my-5" key={id}>
                <div className="profile-header mb-5 position-relative">
                    {userData.id == localStorage.getItem("echo_user") && (
                        <div className="change_cover_img" onClick={() => setShowCoverModal(true)}>
                            <i className="bi bi-image-fill"></i>
                        </div>
                    )}
                    {userData.cover_img && userData.cover_img !== blank_cover ? (
                        <PhotoProvider>
                            <PhotoView src={userData.cover_img}>
                                <img
                                    loading="lazy"
                                    className="cover-photo"
                                    src={userData.cover_img}
                                    alt="cover"
                                    style={{ cursor: 'pointer' }}
                                />
                            </PhotoView>
                        </PhotoProvider>
                    ) : (
                        <img
                            loading="lazy"
                            className="cover-photo"
                            src={blank_cover}
                            alt="cover"
                        />
                    )}


                    <div className="profile-header-content d-flex align-items-end">
                        <div className="profile-photo-wrapper-wrapper">
                            <div className={`profile-photo-wrapper ${vipSettings?.frame ? `vip-frame-${vipSettings.frame}` : 'default-vip-frame'}`}>
                                <PhotoProvider>
                                    <PhotoView src={fullUrl(userData.avatar)}>
                                        <img
                                            loading="lazy"
                                            src={fullUrl(userData.avatar)}
                                            alt="avatar"
                                            className="profile-photo"
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </PhotoView>
                                </PhotoProvider>
                            </div>
                        </div>
                        <div className="profile-info ms-3">
                            <h3
                                className="mb-0 fw-bold"
                                style={{
                                    color: vipSettings?.color || '#ffffff',
                                    fontFamily: vipSettings?.font ? `'${vipSettings.font}', sans-serif` : 'inherit'
                                }}
                            >
                                {userData.display_name}
                            </h3>
                            <small className="d-block" style={{ color: '#ccc' }}>
                                @{userData.echo_nickname}
                            </small>
                            {userData.account_type && (
                                <span className={`badge mt-2 ${
                                    userData.account_type == 1 ? 'bg-danger' :
                                        userData.account_type == 2 ? 'bg-success' :
                                            userData.account_type == 3 ? 'bg-danger' :
                                                userData.account_type == 4 ? 'bg-danger' :
                                                    userData.account_type == 5 ? 'bg-danger' : 'bg-dark'
                                }`}>
                                {userData.account_type == 1 && 'Ověřený účet'}
                                    {userData.account_type == 2 && 'Veřejně známá osoba'}
                                    {userData.account_type == 3 && 'Admin'}
                                    {userData.account_type == 4 && 'Účet sítě Echo'}
                                    {userData.account_type == 5 && 'Účet společnosti'}
                            </span>
                            )}
                        </div>
                    </div>
                </div>

                <div className="g-4">
                    <div className="box row">
                        <div className="col-md-8">
                        <h5 className="text-danger mb-3">O mně</h5>
                            {userData.company == 1 ? (
                                <p className="mb-1"><i className="bi bi-building-fill text-danger"></i> Účet společnosti</p>
                            ) : userData.id !== 29 ? (
                                <p className="mb-1">
                                    {userData.gender === "female" ? (
                                        <>
                                            <i className="bi bi-gender-female text-danger me-2"/> Žena
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-gender-male text-primary me-2"/> Muž
                                        </>
                                    )}
                                </p>
                            ) : (
                                <p className="mb-1">
                                    <i className="bi bi-gender-male text-primary me-2"/> Muž
                                </p>
                            )}

                            {vipSettings && vipSettings.active == 1 && (
                                <p className="mb-1"><LuCrown className="me-2 text-warning" /> Premium</p>
                            )}
                            {userData.relationship > 0 ?
                                <p style={{cursor: "pointer"}}
                                   onClick={() => navigate(`/profile/${userData.relationship}`)}
                                   className="mb-1"><i className="bi bi-heart-fill text-danger me-2"/> Ve
                                    vztahu
                                    s{(userData.relationshipuser.toLowerCase().startsWith("z") || userData.relationshipuser.toLowerCase().startsWith("s")) && ("e")} {userData.relationshipuser}
                                </p> : null}
                            {userData.allflw > 0 && (
                                <p>
                                    <i className="bi bi-people"></i> Sledující: {userData.allflw.toLocaleString('cs-CZ')}{' '}
                                    {Array.isArray(userFlwData) && userFlwData.map((u, index) => (
                                        u.avatar && (
                                            <img
                                                key={index}
                                                src={fullUrl(u.avatar)}
                                                alt="follower"
                                                style={{
                                                    width: 35,
                                                    height: 35,
                                                    borderRadius: '50%',
                                                    marginLeft: 4,
                                                    objectFit: 'cover'
                                                }}
                                                onClick={() => navigate(`/profile/${u.user}`)}
                                            />
                                        )
                                    ))}
                                </p>
                            )}
                            {userData.bio && <p><i className="bi bi-info-circle me-2"/> {userData.bio}</p>}
                            {userData.id != localStorage.getItem("echo_user") && (
                                <Button disabled={flwBtn} size="sm" variant={followed === 1 ? "secondary" : "danger"}
                                        onClick={toggleFollow}>
                                    {followed === 1 ? (
                                        <><i className="bi bi-eye-slash"></i> Přestat sledovat</>
                                    ) : (
                                        <><i className="bi bi-eye-fill"></i> Sledovat</>
                                    )}
                                </Button>
                            )}

                            {userData.id && (
                                <div className="my-3">
                                    <Button size="sm" variant="danger" onClick={() => navigate(`/chat/${userData.id}`)}><i
                                        className="bi bi-send-fill"></i> Napsat
                                        zprávu</Button>
                                </div>
                            )}
                        </div>
                        <div className="col-md-4">
                            {admin && <>
                                <div className="mt-4 p-3 bg-light rounded shadow-sm">
                                    <h6 className="mb-2">Admin informace</h6>
                                    <p className="mb-1">Hráč: <strong>{userData.owner}</strong></p>
                                    {userData.of_boost == 1 ?
                                        <p className="text-success mb-0">Boost: ✅ Aktivní</p> : null}
                                    {userData.echo_ban == 1 ? <p className="text-danger mb-0">Ban: Ano</p> : null}
                                    <Link target="_blank" className="btn-link"
                                          to={`https://fantasyworldtrpg.cz/postava/${userData.id}`}>{userData.allname}</Link>
                                </div>
                            </>}
                        </div>
                    </div>
                </div>
                <div className="mt-5">
                    <div className="d-flex justify-content-center gap-2 mb-4">
                        <button
                            className={`btn ${viewMode === 'timeline' ? 'btn-danger' : 'btn-outline-danger'}`}
                            onClick={() => setViewMode('timeline')}
                        >
                            <i className="bi bi-list"></i> Timeline ({timeLineCount} příspěvků)
                        </button>
                        <button
                            className={`btn ${viewMode === 'gallery' ? 'btn-danger' : 'btn-outline-danger'}`}
                            onClick={() => setViewMode('gallery')}
                        >
                            <i className="bi bi-grid-3x3-gap-fill"></i> Galerie ({galleryCount} fotek)
                        </button>
                    </div>

                    {viewMode === 'timeline' ? (
                        <>
                            {userPosts && Array.isArray(userPosts) && userPosts.map((post, index) => (
                                <Post
                                    key={post.id || index}
                                    post={post}
                                    onlineUsers={onlineUsers}
                                />
                            ))}
                        </>
                    ) : (
                        <div className="row g-2">
                            {userPosts && userPosts.flatMap((post) => {
                                const images = (() => {
                                    try {
                                        const imgs = post.images ? (typeof post.images === 'string' ? JSON.parse(post.images) : post.images) : [];
                                        if (post.image && !imgs.includes(post.image)) {
                                            imgs.unshift(post.image);
                                        }
                                        return imgs;
                                    } catch (error) {
                                        console.error("Chyba při parsování images:", error);
                                        return post.image ? [post.image] : [];
                                    }
                                })();

                                return images.map((img, idx) => (
                                    <div className="col-4 col-md-3 col-lg-2" key={`${post.id}-${idx}`}>
                                        <div
                                            className="position-relative"
                                            style={{
                                                width: '100%',
                                                paddingBottom: '100%',
                                                overflow: 'hidden',
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => navigate(`/post/${post.id}`)}
                                        >
                                            <img
                                                src={img.startsWith('http') ? img : `https://echo.fantasyworldtrpg.cz${img}`}
                                                alt="Galerie"
                                                loading="lazy"
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        </div>
                                    </div>
                                ));
                            })}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Profile;
